var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

export { getOppositeVariationPlacement as default };
//# sourceMappingURL=getOppositeVariationPlacement.js.map
